import { CustomEventProperties } from "core/analytics/analytics.types";

import { BpxQueryCacheHelpers } from "@bps/blocks-core";
import { QueryClient } from "@tanstack/react-query";

export const getContextNameFromUrlBasePath = () => {
  const url = new URL(window.location.href);
  const parts = url.pathname.split("/").filter(Boolean);
  return parts[0];
};

export const getBpxUserAnalyticsParams = (
  queryClient: QueryClient
): CustomEventProperties => {
  const cachedBpxUserModel:
    | {
        isClinicalContributor: boolean;
        isBeta: boolean;
        userRoleText: string;
        userLevel: string;
      }
    | undefined = queryClient.getQueryData(BpxQueryCacheHelpers.user.detail());
  if (!cachedBpxUserModel) {
    return {};
  }
  return {
    isClinical: cachedBpxUserModel.isClinicalContributor,
    isBeta: cachedBpxUserModel.isBeta,
    userRole: cachedBpxUserModel.userRoleText,
    userLevel: cachedBpxUserModel.userLevel
  };
};
